import { mutation$ } from '@atlassian/jira-software-swag/src/services/mutation/index.tsx';

const MUTATION_NAME = 'BacklogDeleteCard';

export const getMutation = () =>
	`mutation ${MUTATION_NAME} ($issueId: ID!) {
        deleteCard(issueId: $issueId) {
            success
        }
    }`;

const cardDeleteGraphql = (baseUrl: string, issueId: string) =>
	// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
	mutation$<void>(baseUrl, MUTATION_NAME, getMutation(), { issueId });

export default cardDeleteGraphql;
